import { motion } from 'framer-motion';
import styled, { css, keyframes } from 'styled-components';

import { ReactComponent as Arrow } from '@pkg/components/Sections/Profile/icons/arrow.svg';
import { LayoutPosition, styledLayout } from '@pkg/primitives';

import { tokens } from '../../tokens';

interface SheetCollapsedWrapperProps {
    $flashing?: boolean;
}

// TODO: Animation still a work-in-progress.
const flashing = keyframes`
    0%,
    10%,
    45%,
    75%,
    100% {
        opacity: 0;
    }
    25%,
    58%,
    85% {
        opacity: 1;
    }
`;

// TODO: Styling can be easier if `framer-motion` supports `calc()`.
// TODO: Styling can be further improved with better breakpoint mixins.

export const SheetCollapsedWrapper = styled(motion.div)<SheetCollapsedWrapperProps>`
    // TODO: This "bottom fixed" variant conflicts with
    // the new Yat navigation bar.
    ${styledLayout.positionCover({ position: LayoutPosition.Fixed })}
    z-index: 10;
    top: auto;
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 20px;
    margin-bottom: -${tokens.collapsed.padding.offscreen}px;
    padding: ${tokens.collapsed.padding.base}px;
    padding-bottom: ${tokens.collapsed.padding.edge}px;
    border-top-left-radius: ${tokens.card.radius}px;
    border-top-right-radius: ${tokens.card.radius}px;
    background-color: ${({ theme }) => theme.colors.purpleDark};
    box-shadow: 0 -6px 20px 2px ${({ theme }) => theme.shades.black['30']};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        top: 0;
        left: auto;
        grid-template-columns: none;
        grid-template-rows: auto 1fr auto;
        margin-bottom: auto;
        margin-right: -${tokens.collapsed.padding.offscreen}px;
        padding-bottom: ${tokens.collapsed.padding.base}px;
        padding-right: ${tokens.collapsed.padding.edge}px;
        height: ${tokens.collapsed.height.tablet}px;
        border-radius: ${tokens.card.radius}px 0 0 ${tokens.card.radius}px;
        box-shadow: -6px 0 20px 2px ${({ theme }) => theme.shades.black['30']};
    }

    ${({ $flashing }) => {
        return (
            $flashing &&
            css`
                animation-name: ${flashing};
                animation-duration: ${({ theme }) => theme.transitions.speeds.slow}s;
                animation-timing-function: ${({ theme }) => theme.transitions.easesCss.cubic};
            `
        );
    }}
`;

export const StyledArrow = styled(Arrow)`
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        transform: rotate(-90deg);
    }
`;
